import { cn } from "@/shared/lib/utils";
import type { Avatar } from "@/shared/protocol";

export const PLAYER_COLORS = [
  "var(--p1)",
  "var(--p2)",
  "var(--p3)",
  "var(--p4)",
  "var(--p5)",
  "var(--p6)",
  "var(--p7)",
  "var(--p8)",
] as const;

// 8 formas SVG simples (path em viewBox 24).
const SHAPES = [
  "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", // círculo
  "M5 5h14v14H5z", // quadrado
  "M12 4l9 16H3z", // triângulo
  "M12 3l7.8 4.5v9L12 21l-7.8-4.5v-9z", // hexágono
  "M12 2l2.6 6.9L22 9.3l-5.5 4.8L18.2 22 12 18l-6.2 4 1.7-7.9L2 9.3l7.4-.4z", // estrela
  "M12 3l7 9-7 9-7-9z", // losango
  "M3 9a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4z", // pílula
  "M4 12c3-7 13-7 16 0-3 7-13 7-16 0z", // olho/gota
];

export function AvatarView({
  avatar,
  nickname,
  size = 40,
  className,
}: {
  avatar: Avatar;
  nickname?: string;
  size?: number;
  className?: string;
}) {
  const color = PLAYER_COLORS[avatar.color % PLAYER_COLORS.length];
  const shape = SHAPES[avatar.shape % SHAPES.length];
  const initial = (nickname ?? "?").trim().charAt(0).toUpperCase();
  return (
    <span
      className={cn("relative inline-flex shrink-0 items-center justify-center", className)}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox="0 0 24 24" width={size} height={size}>
        <path d={shape} fill={color} />
      </svg>
      <span
        className="absolute font-bold"
        style={{ fontSize: size * 0.42, color: "var(--amber-ink)", lineHeight: 1 }}
      >
        {initial}
      </span>
    </span>
  );
}
